import { observer } from 'mobx-react-lite'
import { type MotionValue } from 'motion/react'
import { useAnimationProgress } from '@/contexts/animation-progress-context'
import { type FirmDashboardViewModel } from '@/features/jobs/dashboard/FirmDashboardViewModel'
import { WorkspaceSelectorViewHeadingContainer } from '@/features/iam/workspaces/components/WorkspaceSelectorViewHeading/WorkspaceSelectorViewHeadingContainer'

export interface FirmDashboardViewHeadingContainerProps {
  vm: FirmDashboardViewModel
  compactionAnimationProgress?: MotionValue<number>
}

export const FirmDashboardViewHeadingContainer = observer(
  function FirmDashboardViewHeadingContainer({
    vm,
    compactionAnimationProgress,
  }: FirmDashboardViewHeadingContainerProps) {
    compactionAnimationProgress = useAnimationProgress(
      compactionAnimationProgress,
    )

    return (
      <WorkspaceSelectorViewHeadingContainer
        primaryText={'Dashboard'}
        workspaces={vm.filteredWorkspacesWhereUserCanViewDashboard}
        dropdownTitle="Select workspace"
        onChange={vm.selectWorkspaceForFiltering}
        compactionAnimationProgress={compactionAnimationProgress}
        value={vm.workspaceSelectorVm.workspace}
        searcher={
          vm.workspaceSelectorVm.showWorkspaceSearcher
            ? vm.workspaceSelectorVm
            : undefined
        }
        allOptionText={null}
        alwaysUseDropdown={vm.workspaceSelectorUseDropdown}
      />
    )
  },
)
